"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transliteration_1 = require("transliteration");
const lodash_1 = require("lodash");
exports.osmosysSlugify = (str, shouldTrim = true) => {
    const s = transliteration_1.slugify(str, {
        allowedChars: 'a-zA-Z0-9-',
        lowercase: true,
    });
    return shouldTrim ? lodash_1.trim(s, '-') : s;
};
//# sourceMappingURL=osmosysSlugify.js.map